var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhaseIcons01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#CCD1E0",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#001965"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9963 16.5449V33.0028",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9971 28.5015C18.1983 27.2437 20.8669 27.1089 23.1837 28.1386L24.817 28.8645C27.1338 29.8942 29.8025 29.7594 32.0037 28.5015V16.5456C29.8025 17.8034 27.1339 17.9382 24.8171 16.9085L23.1838 16.1826C20.867 15.1529 18.1983 15.2877 15.9971 16.5456",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhaseIcons01);
export default __webpack_public_path__ + "static/media/Phase Icons 01.1c61451d8817e6172d2e5107f63cf517.svg";
export { ForwardRef as ReactComponent };